import { defineStore } from "pinia"
import { fetchApiJson, postApiJson } from "@/services/repowerAPIService.js"

export const PROCESSING_BUSINESS_DAYS = 2

export default defineStore("repower/contactStore", {
  state: () => ({
    tickets: [],
    loadingTickets: false,
    loadingTicketsFailed: false,
  }),
  actions: {
    resetTickets() {
      this.tickets = []
      this.loadingTickets = false
      this.loadingTicketsFailed = false
    },
    async loadTickets(portfolioId) {
      this.loadingTickets = true
      this.loadingTicketsFailed = false

      try {
        const data = await fetchApiJson(`/users/tickets/${portfolioId}`)
        this.tickets = data
        return this.tickets
      } catch (error) {
        this.tickets = []
        this.loadingTicketsFailed = true
        throw error
      } finally {
        this.loadingTickets = false
      }
    },
    submitForm(category, data, onSuccess, onFail) {
      return postApiJson("/contact/", { category, data })
        .then(onSuccess)
        .catch(onFail)
    },
  },
})
